<pf-listview [items]="serieList" [title]="'serie.title' | translate" [addRouterLink]="'/addserie'"
    [hasSearchSection]="true" [searchPlaceholder]="'serie.searchPlaceholder' | translate">
    <ng-template #itemTemplate let-serie let-i="index">
        <div class="banner-row-layout">
            <div class="name-link" [routerLink]="serie.routerLink">
                {{ serie.serieName }}
            </div>
        </div>
    </ng-template>
</pf-listview>
